import { render } from "./recommendApp.vue?vue&type=template&id=333b707e&scoped=true"
import script from "./recommendApp.vue?vue&type=script&lang=js"
export * from "./recommendApp.vue?vue&type=script&lang=js"

import "./recommendApp.vue?vue&type=style&index=0&id=333b707e&scoped=true&lang=scss"

import exportComponent from "/builds/web-primary/web-novel-stores/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333b707e"]])

export default __exports__